/**
 * Toast holati — `Toast` komponenti uchun.
 *
 * Xabar o'zi o'chadi. Global do'kon qilinmadi: toast bitta ekranga tegishli
 * va ekran almashganda u bilan birga ketishi kerak.
 */

import { useCallback, useEffect, useRef, useState } from 'react';

const VISIBLE_MS = 1900;

export function useToast(): { message: string | null; show: (text: string) => void } {
  const [message, setMessage] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback((text: string) => {
    if (timer.current) clearTimeout(timer.current);
    setMessage(text);
    timer.current = setTimeout(() => setMessage(null), VISIBLE_MS);
  }, []);

  // Ekran yopilganda taymer osilib qolmasin.
  useEffect(() => () => void (timer.current && clearTimeout(timer.current)), []);

  return { message, show };
}
